if (!customElements.get('shipping-confirmation-modal')) {
  class ShippingConfirmationModal extends ModalDialog {
    constructor() {
      super();
      this.confirmButton = this.querySelector('.shipping-confirmation-modal__confirm');
      this.pendingForm = null;
    }

    connectedCallback() {
      super.connectedCallback();
      // The modal gets moved to <body> by ModalDialog.connectedCallback.
      // We need to find our associated product form and fulfillment input by section ID.
      const sectionId = this.id.replace('ShippingConfirmModal-', '');
      this.fulfillmentInput = document.querySelector(
        `input.shipping-confirmation-fulfillment-input[data-section-id="${sectionId}"]`
      );

      // Find the product form element
      const productFormEl = document.getElementById(`product-form-${sectionId}`);
      if (productFormEl) {
        // Intercept submit at capture phase, before product-form.js's handler
        productFormEl.addEventListener('submit', this.onFormSubmit.bind(this), true);
      }

      // Confirm button handler
      if (this.confirmButton) {
        this.confirmButton.addEventListener('click', this.onConfirm.bind(this));
      }
    }

    onFormSubmit(evt) {
      // If the fulfillment input is disabled, the user hasn't confirmed yet
      if (this.fulfillmentInput && this.fulfillmentInput.disabled) {
        evt.preventDefault();
        evt.stopImmediatePropagation(); // Prevent product-form.js handler
        this.pendingForm = evt.target;
        this.show(document.activeElement);
      }
      // If input is enabled, the user has confirmed -- let submission proceed
    }

    onConfirm() {
      // Get selected fulfillment method from radio buttons
      const selected = this.querySelector('input[name^="fulfillment_method"]:checked');
      if (selected && this.fulfillmentInput) {
        this.fulfillmentInput.value = selected.value;
        this.fulfillmentInput.disabled = false;
      }
      this.hide();

      // Re-submit the form immediately after enabling the input
      if (this.pendingForm) {
        // Use a small delay to ensure the modal hide animation starts
        setTimeout(() => {
          if (this.pendingForm) {
            // Trigger the submit button click instead of requestSubmit
            const submitButton = this.pendingForm.querySelector('[type="submit"]');
            if (submitButton) {
              submitButton.click();
            }
            this.pendingForm = null;
          }
        }, 100);
      }
    }

    // Override hide to reset if user dismisses without confirming
    hide() {
      super.hide();
      // Don't reset if we're in the confirm flow (input already enabled)
      if (this.fulfillmentInput && this.fulfillmentInput.disabled) {
        this.pendingForm = null;
      }
    }
  }

  customElements.define('shipping-confirmation-modal', ShippingConfirmationModal);
}
